import { ArrowBackIos, ArrowForwardIos, ShowChart, TrendingDown, TrendingUp } from "@mui/icons-material";
import { Box, Button, FormControl, Grid, LinearProgress, MenuItem, Select, Tab, Typography, styled, Breadcrumbs, useMediaQuery, useTheme } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HttpRequest } from "../HttpRequest";
import imagePlaceHolder from './../../images/img-placeholder.svg';
import { TabContext, TabList, TabPanel } from "@mui/lab";
import CustomTable from "../common/CustomTable";
import CurrencyFormatter from "../common/currencyFormatter";
import salesIcon from "../../images/sales-icon.svg";
import billsIcon from "../../images/bills-icon.svg";
import Slider from "react-slick";
import { DataGrid, GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
import DateFormatter from "../common/dateFormatter";
import CustomSelect from "../common/customSelectInput";
import { startOfToday, startOfYesterday, endOfToday, endOfYesterday, subDays, startOfMonth, endOfMonth, subMonths, format, parse } from 'date-fns';
import { CustomizedDate } from "../common/customDate";
import ExportData from "../common/exportData";
import CustomTabList from "../common/CustomTabList";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";


const getLastMonthRange = (date) => {
  const previousMonth = subMonths(date, 1);
  const start = startOfMonth(previousMonth);
  const end = endOfMonth(previousMonth);
  return { start, end };
};

const orderStatuses = ['Completed', 'Pending', 'Cancelled'];

const Reports = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [tabValue, setTabValue] = useState('Analytics');
  const [orderStatusIndex, setOrderStatusIndex] = useState(0);
  const [dataGridPageSize, setPageSize] = useState(10);
  const [pageState, setPageState] = useState({ isLoading: false, data: [], salesPerProductData: [], total: 0, page: 1, pageSize: dataGridPageSize, });

  const [transactionsState, setTransactionsState] = useState({ isLoading: false, data: [], total: 0, page: 1, pageSize: 10 });
  const [salesPerProductState, setSalesPerProductState] = useState({ isLoading: false, data: [], total: 0, page: 1, pageSize: 10 });
  const [customersState, setCustomersState] = useState({ isLoading: false, data: [], returningColumns: [], total: 0, page: 1, pageSize: 10 });
  const [salesData, setSalesData] = useState([]);
  const [year, setYear] = useState(new Date().getFullYear());
  const [range, setRange] = useState('');
  const [from, setFrom] = useState(null);
  const [to, setTo] = useState(null);
  const [customerType, setCustomerType] = useState('');
  const [orderType, setOrderType] = useState('');
  const [dataToExport, setDataToExport] = useState([]);
  const [dataToExportSalesByProducts, setDataToExportSalesByProducts] = useState([]);
  const [dataToExportTransactions, setDataToExportTransactions] = useState([]);
  const [exportTitle, setExportTitle] = useState('');
  const [tableColumns, setTableColumns] = useState([
    {
      field: 'customerName',
      headerName: 'Customer Name',
    },
    {
      field: 'noOfOrders',
      headerName: 'Number of Orders',
    },
    {
      field: 'totalAmountOfOrders',
      headerName: 'Total Amount of Orders',
    },
    {
      field: 'email',
      headerName: 'Email',
    },
    {
      field: 'phone',
      headerName: 'Phone Number',
    },
  ]);
  const [tableColumnsProducts, setTableColumnsProducts] = useState([
    {
      field: 'productName',
      headerName: 'Product Name',
    },
    {
      field: 'totalSales',
      headerName: 'Total Sales',
    },
    {
      field: 'totalQuantity',
      headerName: 'Total Quantity',
    },
  ]);
  const [tableColumnsTransactions, setTableColumnsTransactions] = useState([
    {
      field: 'orderNumber',
      headerName: 'Order Number',
    },
    {
      field: 'transactionType',
      headerName: 'Transaction Type',
    },
    {
      field: 'transactionID',
      headerName: 'Transaction ID',
    },
    {
      field: 'transamount',
      headerName: 'Transaction Amount',
    },
    {
      field: 'date',
      headerName: 'Date',
    },
    {
      field: 'totalProducts',
      headerName: 'No. of Products',
    },
    {
      field: 'shippingAmount',
      headerName: 'Shipping Amount',
    }
  ]);
  const types = [
    { id: 3, label: 'Orders', value: false },
    { id: 4, label: 'Pre-Orders', value: true },
  ];

  const [topSellingProducts, setTopSellingProducts] = useState([{
    "_id": "MPESA",
    "total": 0,
    "count": 0
  }]);
  const [salesChannels, setSalesChannels] = useState([
    {
      "total": 0,
      "count": 0
    }
  ]);
  const [totalSales, setTotalSales] = useState([
    {
      "total": 0,
      "count": 0
    }
  ]);
  const [totalOrders, setTotalOrders] = useState([
    {
      "total": 0,
      "count": 0
    }
  ]);
  const [totalShipping, setTotalShipping] = useState([
    {
      "total": 0,
      "count": 0,
      "percentageTotal": 0
    }
  ]);
  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };
  let sliderRef = useRef(null);
  const next = () => {
    sliderRef.slickNext();
  };
  const previous = () => {
    sliderRef.slickPrev();
  };
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const tabs = [
    { label: "Analytics", value: "Analytics" },
    { label: "One -Time Customers", value: "OneTimeCustomers" },
    { label: "Returning Customers", value: "ReturningCustomers" },
    { label: "Sales by Payment Mode", value: "SalesByPaymentMode" },
    { label: "Monthly Sales", value: "MonthlySales" },
    { label: "Sales by Products", value: "SalesByProducts" },
    { label: "Transactions", value: "Transactions" },
  ];

  const columns = [
    {
      field: 'customerName', headerName: 'Name', flex: 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: "14px", fontWeight: "700" }}>Name  </Box>) },
      renderCell: (params) => {
        return (<Box onClick={(event) => handleRowClick(event, params)} style={{ cursor: 'pointer', color: "#707070", fontSize: "14px", fontWeight: "550" }}>
          <Typography sx={{ marginTop: '20px', fontFamily: 'Poppins', fontSize: '14px', fontWeight: 550, textAlign: 'left', color: '#000', textDecoration: 'underline' }}>{params?.row?.customerName}</Typography>
        </Box>)
      }
    },
    {
      field: 'email', headerName: 'Email', flex: 1.5,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: "14px", fontWeight: "700" }}> Email  </Box>) },
      renderCell: (params) => {
        return (<Box onClick={(event) => handleRowClick(event, params)} style={{ cursor: 'pointer', color: "#707070", fontSize: "14px", fontWeight: "500" }}>
          <Typography sx={{ marginTop: '20px' }}>{params?.row?.email}</Typography>
        </Box>)
      }
    },
    {
      field: 'phone', headerName: 'Phone No.', flex: 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: "14px", fontWeight: "700" }}> Phone No.</Box>) },
      renderCell: (params) => {
        return (<Box onClick={(event) => handleRowClick(event, params)} style={{ cursor: 'pointer', color: "#707070", fontSize: "14px", fontWeight: "500" }}>
          <Typography sx={{ marginTop: '20px' }}>{params?.row?.phone}</Typography>
        </Box>)
      }
    },
    {
      field: 'totalAmountOfOrders', headerName: 'Amount Spent', flex: 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: "14px", fontWeight: "700" }}> Amount Spent  </Box>) },
      renderCell: (params) => { return (<Box onClick={(event) => handleRowClick(event, params)} style={{ cursor: 'pointer', color: "#707070", fontSize: "14px", fontWeight: "500" }}> Ksh {params?.row?.totalAmountOfOrders} </Box>) }
    },
    {
      field: 'firstOrderDate', headerName: 'First Order Date', flex: 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: "14px", fontWeight: "700" }}>Action </Box>) },
      renderCell: (params) => {
        return (<Box onClick={() => navigate(`/zed_ecommerce/customer/${params?.row?._id}/orders`)} style={{ cursor: 'pointer', color: "#707070", fontSize: "14px", fontWeight: "500" }}>
          <Typography sx={{ marginTop: '20px', textDecoration: 'underline', fontWeight: 550, fontFamily: 'Poppins', color: '#000', fontSize: '14px' }}>View Order</Typography>
        </Box>)
      }
    },

  ]
  const returningColumns = [
    {   
      field: 'customerName', headerName: 'Name', flex: 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: "14px", fontWeight: "700" }}>Name  </Box>) },
      renderCell: (params) => {
        return (<Box onClick={(event) => handleRowClick(event, params)} style={{ cursor: 'pointer', color: "#707070", fontSize: "14px", fontWeight: "550" }}>
          <Grid container spacing={2} sx={{ display: 'flex' }}>
            <Grid item>
              <Typography sx={{ marginTop: '20px', fontFamily: 'Poppins', fontSize: '14px', fontWeight: 550, textAlign: 'left', color: '#000', textDecoration: 'underline' }}>{params?.row?.customerName}</Typography>
            </Grid>
          </Grid>
        </Box>)
      }
    },
    {
      field: 'email', headerName: 'Email', flex: 1.5,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: "14px", fontWeight: "700" }}> Email  </Box>) },
      renderCell: (params) => {
        return (<Box onClick={(event) => handleRowClick(event, params)} style={{ cursor: 'pointer', color: "#707070", fontSize: "14px", fontWeight: "500" }}>
          <Typography sx={{ marginTop: '20px' }}>{params?.row?.email}</Typography>
        </Box>)
      }
    },
    {
      field: 'phone', headerName: 'Phone No.', flex: 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: "14px", fontWeight: "700" }}> Phone No.</Box>) },
      renderCell: (params) => {
        return (<Box onClick={(event) => handleRowClick(event, params)} style={{ cursor: 'pointer', color: "#707070", fontSize: "14px", fontWeight: "500" }}>
          <Typography sx={{ marginTop: '20px' }}>{params?.row?.phone}</Typography>
        </Box>)
      }
    },
    {
      field: 'noOfOrders', headerName: 'Orders', flex: 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: "14px", fontWeight: "700" }}> Orders </Box>) },
      renderCell: (params) => {
        return (<Box onClick={(event) => navigate(`/zed_ecommerce/customer/${params?.row?._id}/orders`)} style={{ cursor: 'pointer', color: "#707070", fontSize: "14px", fontWeight: "500" }}>
          <Typography sx={{ marginTop: '20px', textDecoration: 'underline', fontWeight: 550, color: '#000', fontSize: '14px' }}>{params?.row?.noOfOrders} Orders</Typography>
        </Box>)
      }
    },
    {
      field: 'totalAmountOfOrders', headerName: 'Amount Spent', flex: 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: "14px", fontWeight: "700" }}> Amount Spent  </Box>) },
      renderCell: (params) => { return (<Box onClick={(event) => handleRowClick(event, params)} style={{ cursor: 'pointer', color: "#707070", fontSize: "14px", fontWeight: "500" }}> Ksh {params?.row?.totalAmountOfOrders} </Box>) }
    },
  ]
  const salesPerChannel = [
    {
      field: '_id', headerName: 'Payment Mode', flex: 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: "14px", fontWeight: "700" }}> Payment Mode  </Box>) },
      renderCell: (params) => {
        return (<Box style={{ cursor: 'pointer', color: "#707070", fontSize: "14px", fontWeight: "500" }}>
          <Typography sx={{ marginTop: '20px' }}>{params?.row?._id}</Typography>
        </Box>)
      }
    },
    {
      field: 'count', headerName: 'Quantity', flex: 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: "14px", fontWeight: "700" }}>Total Quantity</Box>) },
      renderCell: (params) => {
        return (<Box style={{ cursor: 'pointer', color: "#707070", fontSize: "14px", fontWeight: "500" }}>
          <Typography sx={{ marginTop: '20px' }}>{params?.row?.count}</Typography>
        </Box>)
      }
    },
    {
      field: 'total', headerName: 'Total Sales', flex: 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: "14px", fontWeight: "700" }}> Total Sales  </Box>) },
      renderCell: (params) => { return (<Box style={{ cursor: 'pointer', color: "#707070", fontSize: "14px", fontWeight: "500" }}> {CurrencyFormatter(params?.row?.total)} </Box>) }
    },
  ]
  const salesPerProductColumns = [
    {
      field: 'productName', headerName: 'Name', flex: 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: "14px", fontWeight: "700" }}> Name  </Box>) },
      renderCell: (params) => {
        return (<Box style={{ cursor: 'pointer', color: "#707070", fontSize: "14px", fontWeight: "500" }}>
          <Typography sx={{ marginTop: '20px' }}>{params?.row?.productName}</Typography>
        </Box>)
      }
    },
    {
      field: 'totalQuantity', headerName: 'Quantity', flex: 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: "14px", fontWeight: "700" }}>Quantity</Box>) },
      renderCell: (params) => {
        return (<Box style={{ cursor: 'pointer', color: "#707070", fontSize: "14px", fontWeight: "500" }}>
          <Typography sx={{ marginTop: '20px' }}>{params?.row?.totalQuantity}</Typography>
        </Box>)
      }
    },
    {
      field: 'totalSales', headerName: 'Total Sales', flex: 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: "14px", fontWeight: "700" }}> Total Sales  </Box>) },
      renderCell: (params) => { return (<Box style={{ cursor: 'pointer', color: "#707070", fontSize: "14px", fontWeight: "500" }}> {CurrencyFormatter(params?.row?.totalSales)} </Box>) }
    },
  ]
  const monthlySalesColumns = [
    {
      field: 'month', headerName: 'Month', flex: 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: "14px", fontWeight: "700" }}> Month  </Box>) },
      renderCell: (params) => {
        return (<Box style={{ cursor: 'pointer', color: "#707070", fontSize: "14px", fontWeight: "500" }}>
          <Typography sx={{ marginTop: '20px' }}>{params?.row?.month}</Typography>
        </Box>)
      }
    },
    {
      field: 'totalSales', headerName: 'Total Sales', flex: 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: "14px", fontWeight: "700" }}>Total Sales</Box>) },
      renderCell: (params) => {
        return (<Box style={{ cursor: 'pointer', color: "#707070", fontSize: "14px", fontWeight: "500" }}>
          <Typography sx={{ marginTop: '20px' }}>{params?.row?.totalSales}</Typography>
        </Box>)
      }
    },
  ]
  const transactionsColumns = [
    {
      field: 'transactionID', headerName: 'TXN ID', flex: 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: "14px", fontWeight: "700" }}> TXN ID  </Box>) },
      renderCell: (params) => {
        return (<Box style={{ cursor: 'pointer', color: "#707070", fontSize: "14px", fontWeight: "500" }}>
          <Typography sx={{ marginTop: '20px' }}>{params?.row?.transactionID}</Typography>
        </Box>)
      }
    },
    {
      field: 'orderNumber', headerName: 'Order No.', flex: 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: "14px", fontWeight: "700" }}>Order No.</Box>) },
      renderCell: (params) => {
        return (<Box style={{ cursor: 'pointer', color: "#707070", fontSize: "14px", fontWeight: "500" }}>
          <Typography sx={{ marginTop: '20px' }}>{params?.row?.orderNumber}</Typography>
        </Box>)
      }
    },
    {
      field: 'transtime', headerName: 'TXN Date', flex: 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: "14px", fontWeight: "700" }}> TXN Date </Box>) },
      renderCell: (params) => { return (<Box style={{ cursor: 'pointer', color: "#707070", fontSize: "14px", fontWeight: "500" }}> {DateFormatter(params?.row?.transtime)} </Box>) }
    },
    {
      field: 'totalProducts', headerName: 'No of Products', flex: 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: "14px", fontWeight: "700" }}> No of Products  </Box>) },
      renderCell: (params) => {
        return (<Box style={{ cursor: 'pointer', color: "#707070", fontSize: "14px", fontWeight: "500" }}>
          <Typography sx={{ marginTop: '20px' }}>{params?.row?.totalProducts}</Typography>
        </Box>)
      }
    },
    {
      field: 'shippingFees', headerName: 'Shipping Fees', flex: 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: "14px", fontWeight: "700" }}>Shipping Fees</Box>) },
      renderCell: (params) => {
        return (<Box style={{ cursor: 'pointer', color: "#707070", fontSize: "14px", fontWeight: "500" }}>
          <Typography sx={{ marginTop: '20px' }}>{CurrencyFormatter(params?.row?.shippingFees ?? 0)}</Typography>
        </Box>)
      }
    },
    {
      field: 'transamount', headerName: 'Total Sales', flex: 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: "14px", fontWeight: "700" }}> Total Sales  </Box>) },
      renderCell: (params) => { return (<Box style={{ cursor: 'pointer', color: "#707070", fontSize: "14px", fontWeight: "500" }}> {CurrencyFormatter(params?.row?.transamount)} </Box>) }
    },
  ]
  const getSalesPerProduct = () => {
    setSalesPerProductState((old) => ({ ...old, isLoading: true }));
    const url = `/api/v1/ecommerce/getall-salesbyproduct`;
    HttpRequest({
      method: 'GET',
      url: `${url}?page=${salesPerProductState?.page}&limit=${salesPerProductState?.pageSize}&startDate=${from ?? ''}&endDate=${to ?? ''}`,
    }).then((data) => {
      setSalesPerProductState({
        ...salesPerProductState,
        data: data?.response?.data,
        total: data?.response?.count,
        isLoading: false,
      });
      getDataToExportProducts(`${url}?page=${salesPerProductState?.page}&limit=${data?.response?.count}&startDate=${from ?? ''}&endDate=${to ?? ''}`);

    }).catch((error) => {
      setSalesPerProductState((old) => ({ ...old, isLoading: false }));
    });
  };

  const getTransactions = () => {
    setTransactionsState((old) => ({ ...old, isLoading: true }));
    const url = `/api/v1/ecommerce/admin-get-transactions`;
    HttpRequest({
      method: 'GET',
      url: `${url}?page=${transactionsState.page}&limit=${transactionsState.pageSize}&startDate=${from ?? ''}&endDate=${to ?? ''}&isPreOrder=${orderType}`,
    }).then((data) => {
      setTransactionsState({
        ...transactionsState,
        data: data?.response?.data,
        total: data?.response?.count,
        isLoading: false,
      });
      getDataToExportTransactions(`${url}?page=${transactionsState.page}&limit=${data?.response?.count}&startDate=${from ?? ''}&endDate=${to ?? ''}&isPreOrder=${orderType}`);
    }).catch((error) => {
      setTransactionsState((old) => ({ ...old, isLoading: false }));
    });
  };

  const getCustomers = () => {
    setCustomersState((old) => ({ ...old, isLoading: true }));
    const url = `/api/v1/ecommerce/getzedecommercecustomers`;
    HttpRequest({
      method: 'GET',
      url: `${url}?page=${customersState?.page}&limit=${customersState?.pageSize}&customerType=${customerType}`,
    }).then((data) => {
      setCustomersState({
        ...customersState,
        data: data?.response?.data,
        total: data?.response?.count,
        isLoading: false,
      });
      getDataToExport(`${url}?page=${customersState?.page}&limit=${data?.response?.count}&customerType=${customerType}`);
    }).catch((error) => {
      setCustomersState((old) => ({ ...old, isLoading: false }));
    });
  };
  const getDataToExport = (url) => {
    return HttpRequest({
      method: 'GET',
      url: url
    }).then((data) => {
      const filteredCustomers = data?.response?.data?.map(({ _id, customerId, businessNumber, ...rest }) => ({
        ...rest,
      }));
      setDataToExport(filteredCustomers);
      return filteredCustomers;
    }).catch((error) => {
      throw error;
    });
  };
  const getDataToExportProducts = async (url) => {
    try {
      const data = await HttpRequest({
        method: 'GET',
        url: url
      });
      const filteredProducts = data?.response?.data?.map(({ _id, ...rest }) => ({
        ...rest,
      }));
      setDataToExportSalesByProducts(filteredProducts??salesPerProductState?.data);
      return data?.response?.data;
    } catch (error) {
      throw error;
    }
  };
  const getDataToExportTransactions = (url) => {
    return HttpRequest({
      method: 'GET',
      url: url
    }).then((data) => {
      const filteredTransactions = data?.response?.data?.map(({ _id, pushyId, transtime, businessNo, ...rest }) => ({
        ...rest,
        date: DateFormatter(transtime),
      }));
      setDataToExportTransactions(filteredTransactions);
      return filteredTransactions;
    }).catch((error) => {
      throw error;
    });
  };

  const getTopSellingProducts = () => {
    setPageState({
      ...pageState,
      data: [],
      total: 0,
      isLoading: true
    })
    HttpRequest({
      method: 'GET',
      url: `/api/v1/ecommerce/getzedecommerce-top-selling-products`
    }).then((data) => {
      setTopSellingProducts(data?.response);
    }).catch((error) => {
    });
  }
  const getTopSalesAnalytics = (status = '') => {
    setPageState({
      ...pageState,
      data: [],
      total: 0,
      isLoading: true
    })
    HttpRequest({
      method: 'GET',
      url: `/api/v1/ecommerce/getzedecommercesalesanalytics${status ? `?status=${status.toLowerCase()}` : ''}`
    }).then((data) => {
      setSalesChannels(data?.response?.salesByChannel);
      setTotalSales(data?.response?.totalSales);
      setTotalOrders(data?.response?.totalOrders);
    }).catch((error) => {
    });
  }
  const getShippingTotals = () => {
    setPageState({
      ...pageState,
      data: [],
      total: 0,
      isLoading: true
    })
    HttpRequest({
      method: 'GET',
      url: `/api/v1/ecommerce/getzedecommerce-shipping-totals`
    }).then((data) => {
      setTotalShipping(data?.response?.data);
    }).catch((error) => {
    });
  }
  useEffect(() => {
    getTopSellingProducts();
    getTopSalesAnalytics();
    getShippingTotals();
    salesActivity();
  }, []);

  useEffect(() => {
    getTopSalesAnalytics(orderStatuses[orderStatusIndex]);
  }, [orderStatusIndex]);

  useEffect(() => {
    getTransactions();
  }, [transactionsState?.page, transactionsState?.pageSize, from, to, orderType]);
  useEffect(() => {
    getCustomers();
  }, [customersState?.page, customersState?.pageSize, customerType]);

  useEffect(() => {
    getSalesPerProduct();
  }, [salesPerProductState.page, salesPerProductState.pageSize, from, to]);

  const handleChangeFilter = (event) => {

  };
  const handleRowClick = (event, params) => {
    event.stopPropagation();
    navigate(`/zed_ecommerce/customer/${params?.row?._id}/details`);
  }

  function CustomToolbar() {
    return (
      <GridToolbarContainer sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', padding: '8px', mr: '20px',verticalAlign:'middle' }}>
        {tabValue === 'Transactions' && <Box sx={{ mr: '2%', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
          <CustomSelect sx={{ mr: '10px', mt: '8px' }} value={orderType} placeholder='Order Type' options={types} sm={"xs"} onChange={(e) => setOrderType(e.target.value)} />
        </Box>}
        {(tabValue === 'Transactions' || tabValue === 'SalesByProducts') &&
          <Box sx={{ mr: '2%', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            <CustomSelect
              sx={{ mr: '10px', mt: '8px' }}
              value={range}
              options={ranges}
              sm={"lg"}
              onChange={(e) => setRange(e.target.value)}
            />
            {range === 'customDate' && (
              <CustomizedDate setDateFrom={setFrom} setDateTo={setTo} style={{ display: "flex", alignItems: "center" }} />
            )}
          </Box>}
        <ExportData
          data={
            tabValue === 'OneTimeCustomers' || tabValue === 'ReturningCustomers'
              ? dataToExport
              : tabValue === 'SalesByProducts'
                ? dataToExportSalesByProducts
                : tabValue === 'Transactions'
                  ? dataToExportTransactions
                  : null
          }
          tableColumn={
            tabValue === 'OneTimeCustomers' || tabValue === 'ReturningCustomers'
              ? tableColumns
              : tabValue === 'SalesByProducts'
                ? tableColumnsProducts
                : tabValue === 'Transactions'
                  ? tableColumnsTransactions
                  : null
          }
          title={exportTitle}
          otherData={{
            year: year,
            from: from,
            to: to,
            customerType: customerType,
            orderType: orderType,
            searchValue: "",
            reportType: "productSales"
          }}
        />

      </GridToolbarContainer>
    );
  }
  const salesActivity = async () => {
    HttpRequest({
      method: 'GET',
      url: `/api/v1/ecommerce/zed_ecommerce_sales_activity?year=${year}`,
      body: null,
    }).then((data) => {
      if (data.status === 200) {
        setSalesData(data?.response?.data);
      }
    }).catch((error) => {
    })
  }
  const ranges = [
    { id: 1, label: 'Select Date', value: '' },
    { id: 2, label: 'Today', value: 'today' },
    { id: 3, label: 'Yesterday', value: 'yesterday' },
    { id: 4, label: 'Last 7 Days', value: 'oneWeek' },
    { id: 5, label: 'This Month', value: 'thisMonth' },
    { id: 6, label: 'Last Month', value: 'lastMonth' },
    { id: 7, label: 'Custom Range', value: 'customDate' },
  ];
  useEffect(() => {
    const updateDates = (range) => {
      const today = new Date();
      let fromDate = null;
      let toDate = null;

      switch (range) {
        case 'today':
          fromDate = format(startOfToday(), 'MM/dd/yyyy');
          toDate = format(endOfToday(), 'MM/dd/yyyy');
          break;
        case 'yesterday':
          fromDate = format(startOfYesterday(), 'MM/dd/yyyy');
          toDate = format(endOfYesterday(), 'MM/dd/yyyy');
          break;
        case 'oneWeek':
          fromDate = format(subDays(today, 7), 'MM/dd/yyyy');
          toDate = format(endOfToday(), 'MM/dd/yyyy');
          break;
        case 'thisMonth':
          fromDate = format(startOfMonth(today), 'MM/dd/yyyy');
          toDate = format(endOfMonth(today), 'MM/dd/yyyy');
          break;
        case 'lastMonth':
          ({ start: fromDate, end: toDate } = getLastMonthRange(today));
          fromDate = format(fromDate, 'MM/dd/yyyy');
          toDate = format(toDate, 'MM/dd/yyyy');
          break;
        default:
          fromDate = null;
          toDate = null;
          break;
      }

      setFrom(fromDate);
      setTo(toDate);
    };

    updateDates(range);
  }, [range,from,to]);

  const breadcrumbs = [
      <Typography key="X" sx={{ color: "#707070", fontSize: "0.875rem" }}>
          Dashboard
      </Typography>,
      <Typography key={"add"} sx={{ color: "#dc3545", fontSize: "0.875rem" }}>
          Reports
      </Typography>
    ];

  return (
    <Box sx={{ mt: { xs: '20%', sm: '5%' }, width: { xs: '100vw', sm: 'calc(100vw - 380px)' }, maxWidth: '100%', overflowX: 'hidden', boxSizing: 'border-box', px: { xs: 2, sm: 3 }, pb: 5, ml: { xs: -3, sm: 0 } }}>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h4" sx={{ color: "#032541", fontSize: { xs: "20px", sm: "24px", md: "28px" }, fontWeight: "600", mb: 0.5 }}>
          Reports
        </Typography>
        <Breadcrumbs sx={{ fontFamily: 'Poppins', fontSize: { xs: '12px', sm: '14px' }, mb: 1 }} separator={<FiberManualRecordIcon style={{ fontSize: "0.5rem", color: "#e1e5e8" }} />} aria-label="breadcrumb">
          {breadcrumbs}
        </Breadcrumbs>
        <Typography sx={{ color: "#707070", fontSize: { xs: "12px", sm: "14px" }, fontWeight: "normal" }}>View and manage your Reports</Typography>
      </Box>
      <Box>
        <TabContext value={tabValue}>
          <CustomTabList tabs={tabs} onChange={handleChange}/>
          <TabPanel value="Analytics" sx={{ px: 0 }}>
            <Box>
              {/* Top Stats Cards */}
              <Grid container spacing={isMobile ? 1.5 : 2} sx={{ mb: { xs: 2, sm: 4 } }}>
                <Grid item xs={12} sm={6} md={4}>
                  <Box onClick={() => setTabValue('Transactions')} sx={{ cursor: 'pointer', height: '100%', p: { xs: 2, sm: 3 }, borderRadius: '12px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05)', backgroundColor: '#fff', transition: 'all 0.3s ease', '&:hover': { transform: 'translateY(-3px)', boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12), 0 4px 8px rgba(0, 0, 0, 0.06)' } }}>
                    <Typography sx={{ fontFamily: 'Poppins', fontSize: { xs: '14px', sm: '16px' }, fontWeight: 600, color: '#032541', mb: { xs: 1.5, sm: 2 } }}>Total Sales</Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Box sx={{ backgroundColor: 'rgba(23, 174, 123, 0.1)', borderRadius: '12px', p: { xs: 1, sm: 1.5 }, mr: { xs: 1.5, sm: 2 }, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <TrendingUp sx={{ fontSize: { xs: 24, sm: 32 }, color: '#17ae7b' }} />
                      </Box>
                      {totalSales?.map((sale, idx) => (
                        <Box key={idx}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <Typography sx={{ fontFamily: 'Poppins', fontSize: { xs: '12px', sm: '14px' }, fontWeight: 'bold', color: '#231f20' }}>{sale?.count}</Typography>
                            <Typography sx={{ fontFamily: 'Poppins', fontSize: { xs: '12px', sm: '14px' }, color: '#707070' }}>Transactions</Typography>
                          </Box>
                          <Typography sx={{ fontFamily: 'Poppins', fontSize: { xs: '18px', sm: '24px' }, fontWeight: 'bold', color: '#17ae7b', mt: 0.5 }}>Ksh {sale?.total?.toLocaleString()}</Typography>
                          <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
                            <Typography sx={{ fontFamily: 'Poppins', fontSize: { xs: '11px', sm: '13px' }, fontWeight: 600, color: '#17ae7b', mr: 0.5 }}>+10.01%</Typography>
                            <TrendingUp sx={{ fontSize: { xs: 14, sm: 16 }, color: '#17ae7b' }} />
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Box onClick={() => navigate('/zed_ecommerce/orders')} sx={{ cursor: 'pointer', height: '100%', p: { xs: 2, sm: 3 }, borderRadius: '12px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05)', backgroundColor: '#fff', transition: 'all 0.3s ease', '&:hover': { transform: 'translateY(-3px)', boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12), 0 4px 8px rgba(0, 0, 0, 0.06)' } }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: { xs: 1.5, sm: 2 } }}>
                      <Typography sx={{ fontFamily: 'Poppins', fontSize: { xs: '14px', sm: '16px' }, fontWeight: 600, color: '#032541' }}>Total Orders</Typography>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <ArrowBackIos
                          sx={{ fontSize: { xs: 12, sm: 16 }, color: orderStatusIndex === 0 ? '#e0e0e0' : '#707070', cursor: 'pointer', '&:hover': { color: orderStatusIndex === 0 ? '#e0e0e0' : '#032541' } }}
                          onClick={(e) => { e.stopPropagation(); if (orderStatusIndex > 0) setOrderStatusIndex(orderStatusIndex - 1); }}
                        />
                        <Typography sx={{ mx: 0.5, fontFamily: 'Poppins', fontSize: { xs: '10px', sm: '12px' }, color: '#3da2f8', backgroundColor: 'rgba(61, 162, 248, 0.1)', px: { xs: 1, sm: 1.5 }, py: 0.5, borderRadius: '20px' }}>{orderStatuses[orderStatusIndex]}</Typography>
                        <ArrowForwardIos
                          sx={{ fontSize: { xs: 12, sm: 16 }, color: orderStatusIndex === orderStatuses.length - 1 ? '#e0e0e0' : '#707070', cursor: 'pointer', '&:hover': { color: orderStatusIndex === orderStatuses.length - 1 ? '#e0e0e0' : '#032541' } }}
                          onClick={(e) => { e.stopPropagation(); if (orderStatusIndex < orderStatuses.length - 1) setOrderStatusIndex(orderStatusIndex + 1); }}
                        />
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Box sx={{ backgroundColor: 'rgba(61, 162, 248, 0.1)', borderRadius: '12px', p: { xs: 1, sm: 1.5 }, mr: { xs: 1.5, sm: 2 }, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img src={billsIcon} alt="" style={{ width: isMobile ? '24px' : '32px', height: isMobile ? '24px' : '32px', objectFit: 'contain' }} />
                      </Box>
                      {totalOrders?.map((order, idx) => (
                        <Box key={idx}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <Typography sx={{ fontFamily: 'Poppins', fontSize: { xs: '12px', sm: '14px' }, fontWeight: 'bold', color: '#231f20' }}>{order.count}</Typography>
                            <Typography sx={{ fontFamily: 'Poppins', fontSize: { xs: '12px', sm: '14px' }, color: '#707070' }}>{orderStatuses[orderStatusIndex]}</Typography>
                          </Box>
                          <Typography sx={{ fontFamily: 'Poppins', fontSize: { xs: '18px', sm: '24px' }, fontWeight: 'bold', color: '#3da2f8', mt: 0.5 }}>Ksh {order.total?.toLocaleString()}</Typography>
                          <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
                            <Typography sx={{ fontFamily: 'Poppins', fontSize: { xs: '11px', sm: '13px' }, fontWeight: 600, color: '#17ae7b', mr: 0.5 }}>+1.01%</Typography>
                            <TrendingUp sx={{ fontSize: { xs: 14, sm: 16 }, color: '#17ae7b' }} />
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={4}>
                  <Box sx={{ cursor: 'pointer', height: '100%', p: { xs: 2, sm: 3 }, borderRadius: '12px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05)', backgroundColor: '#fff', transition: 'all 0.3s ease', '&:hover': { boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12), 0 4px 8px rgba(0, 0, 0, 0.06)' } }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: { xs: 1.5, sm: 2 } }}>
                      <Typography sx={{ fontFamily: 'Poppins', fontSize: { xs: '14px', sm: '16px' }, fontWeight: 600, color: '#032541' }}>Sales by Channel</Typography>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <ArrowBackIos sx={{ fontSize: { xs: 12, sm: 16 }, color: '#707070', cursor: 'pointer', '&:hover': { color: '#032541' } }} onClick={(e) => { e.stopPropagation(); previous(); }} />
                        <ArrowForwardIos sx={{ fontSize: { xs: 12, sm: 16 }, color: '#707070', cursor: 'pointer', ml: 1, '&:hover': { color: '#032541' } }} onClick={(e) => { e.stopPropagation(); next(); }} />
                      </Box>
                    </Box>
                    <Slider ref={slider => { sliderRef = slider; }} {...settings}>
                      {salesChannels?.map((channel, index) => (
                        <Box key={index} onClick={() => setTabValue('SalesByPaymentMode')}>
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                            <Typography sx={{ fontFamily: 'Poppins', fontSize: { xs: '10px', sm: '12px' }, color: '#f79009', backgroundColor: 'rgba(247, 144, 9, 0.1)', px: { xs: 1, sm: 1.5 }, py: 0.5, borderRadius: '20px' }}>{channel?._id || 'N/A'}</Typography>
                          </Box>
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Box sx={{ backgroundColor: 'rgba(247, 144, 9, 0.1)', borderRadius: '12px', p: { xs: 1, sm: 1.5 }, mr: { xs: 1.5, sm: 2 }, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              <ShowChart sx={{ fontSize: { xs: 24, sm: 32 }, color: '#f79009' }} />
                            </Box>
                            <Box>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                <Typography sx={{ fontFamily: 'Poppins', fontSize: { xs: '12px', sm: '14px' }, fontWeight: 'bold', color: '#231f20' }}>{channel?.count || 0}</Typography>
                                <Typography sx={{ fontFamily: 'Poppins', fontSize: { xs: '12px', sm: '14px' }, color: '#707070' }}>Transactions</Typography>
                              </Box>
                              <Typography sx={{ fontFamily: 'Poppins', fontSize: { xs: '18px', sm: '24px' }, fontWeight: 'bold', color: '#f79009', mt: 0.5 }}>Ksh {channel?.total?.toLocaleString() || 0}</Typography>
                              <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
                                <Typography sx={{ fontFamily: 'Poppins', fontSize: { xs: '11px', sm: '13px' }, fontWeight: 600, color: '#dc3545', mr: 0.5 }}>-1.01%</Typography>
                                <TrendingDown sx={{ fontSize: { xs: 14, sm: 16 }, color: '#dc3545' }} />
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      ))}
                    </Slider>
                  </Box>
                </Grid>
              </Grid>
              {/* Total Shipping Fees - Full Width */}
              <Box sx={{ mt: { xs: 4, sm: 10 }, p: { xs: 2, sm: 3 }, borderRadius: '12px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05)', backgroundColor: '#fff', transition: 'all 0.3s ease', '&:hover': { boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12), 0 4px 8px rgba(0, 0, 0, 0.06)' } }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: { xs: 2, sm: 3 }, flexDirection: { xs: 'column', sm: 'row' }, gap: { xs: 1.5, sm: 0 } }}>
                  <Box>
                    <Typography sx={{ fontFamily: 'Poppins', fontSize: { xs: '14px', sm: '16px' }, fontWeight: 600, color: '#032541' }}>Total Shipping Fees</Typography>
                    <Typography sx={{ fontFamily: 'Poppins', fontSize: { xs: '11px', sm: '13px' }, color: '#707070', mt: 0.5 }}>Delivery charges breakdown by payment method</Typography>
                  </Box>
                  <FormControl size="small">
                    <Select sx={{ minWidth: { xs: '100px', sm: '120px' }, borderRadius: '8px', backgroundColor: 'rgba(0, 0, 0, 0.03)', fontSize: { xs: '12px', sm: '14px' } }} value="Weekly" onChange={handleChangeFilter}>
                      <MenuItem value="Daily">Daily</MenuItem>
                      <MenuItem value="Weekly">Weekly</MenuItem>
                      <MenuItem value="Monthly">Monthly</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
                <Grid container spacing={{ xs: 2, sm: 3 }}>
                  {totalShipping?.map((shipping, index) => (
                    <Grid item xs={12} md={6} key={index}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 2 }, flexWrap: { xs: 'wrap', sm: 'nowrap' } }}>
                        <Typography sx={{ fontFamily: 'Poppins', fontSize: { xs: '12px', sm: '14px' }, fontWeight: 500, color: '#707070', minWidth: { xs: '60px', sm: '80px' } }}>{shipping?._id} Txn</Typography>
                        <Typography sx={{ fontFamily: 'Poppins', fontSize: { xs: '14px', sm: '18px' }, fontWeight: 600, color: index % 2 === 0 ? '#17ae7b' : '#22409a', minWidth: { xs: '100px', sm: '140px' } }}>Ksh {shipping?.total?.toLocaleString()}</Typography>
                        <Box sx={{ flex: 1, minWidth: { xs: '100%', sm: 'auto' }, mt: { xs: 1, sm: 0 } }}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                            <Typography sx={{ fontFamily: 'Poppins', fontSize: { xs: '11px', sm: '13px' }, color: '#707070' }}>{shipping?.count} Transactions</Typography>
                            <Typography sx={{ fontFamily: 'Poppins', fontSize: { xs: '11px', sm: '13px' }, color: '#707070' }}>{shipping?.percentageTotal?.toFixed(2) ?? 0}%</Typography>
                          </Box>
                          <LinearProgress color={index % 2 === 0 ? 'success' : 'primary'} value={shipping?.percentageTotal} variant="determinate" sx={{ height: { xs: '5px', sm: '6px' }, borderRadius: '3px' }} />
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Box>

              {/* Top 5 Selling Products - Full Width */}
              <Box sx={{ mt: { xs: 2, sm: 3 }, p: { xs: 2, sm: 3 }, borderRadius: '12px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05)', backgroundColor: '#fff', transition: 'all 0.3s ease', '&:hover': { boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12), 0 4px 8px rgba(0, 0, 0, 0.06)' } }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: { xs: 2, sm: 3 }, flexDirection: { xs: 'column', sm: 'row' }, gap: { xs: 1.5, sm: 0 } }}>
                  <Box>
                    <Typography sx={{ fontFamily: 'Poppins', fontSize: { xs: '14px', sm: '16px' }, fontWeight: 600, color: '#032541' }}>Top 5 Selling Products</Typography>
                    <Typography sx={{ fontFamily: 'Poppins', fontSize: { xs: '11px', sm: '13px' }, color: '#707070', mt: 0.5 }}>Best performing products by revenue</Typography>
                  </Box>
                  <FormControl size="small">
                    <Select sx={{ minWidth: { xs: '100px', sm: '120px' }, borderRadius: '8px', backgroundColor: 'rgba(0, 0, 0, 0.03)', fontSize: { xs: '12px', sm: '14px' } }} value="Monthly" onChange={handleChangeFilter}>
                      <MenuItem value="Daily">Daily</MenuItem>
                      <MenuItem value="Weekly">Weekly</MenuItem>
                      <MenuItem value="Monthly">Monthly</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', p: { xs: 1, sm: 1.5 }, borderRadius: '8px', backgroundColor: '#f5f6f7', mb: 1 }}>
                  <Typography sx={{ fontFamily: 'Poppins', fontSize: { xs: '12px', sm: '14px' }, fontWeight: 600, color: '#032541' }}>Product Name</Typography>
                  <Typography sx={{ fontFamily: 'Poppins', fontSize: { xs: '12px', sm: '14px' }, fontWeight: 600, color: '#032541' }}>Amount (KES)</Typography>
                </Box>
                {topSellingProducts?.map((product, idx) => (
                  <Box key={idx} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: { xs: 1, sm: 1.5 }, borderBottom: '1px solid #f0f0f0' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <img src={imagePlaceHolder} alt="" style={{ width: isMobile ? '28px' : '36px', height: isMobile ? '28px' : '36px', objectFit: 'contain', borderRadius: '8px', marginRight: isMobile ? '8px' : '12px' }} />
                      <Typography sx={{ fontFamily: 'Poppins', fontSize: { xs: '12px', sm: '14px' }, fontWeight: 500, color: '#707070' }}>{product.itemName}</Typography>
                    </Box>
                    <Typography sx={{ fontFamily: 'Poppins', fontSize: { xs: '12px', sm: '14px' }, fontWeight: 600, color: '#17ae7b' }}>{product.totalSales?.toLocaleString()}</Typography>
                  </Box>
                ))}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                  <Typography onClick={() => setTabValue('SalesByProducts')} sx={{ fontFamily: 'Poppins', fontSize: { xs: '12px', sm: '14px' }, fontWeight: 500, color: '#3da2f8', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}>View More →</Typography>
                </Box>
              </Box>
            </Box>
          </TabPanel>
          <TabPanel value="OneTimeCustomers" sx={{ ml: { xs: 0, sm: '-30px' }, px: { xs: 0, sm: 3 } }}>
            <Grid item>
              <DataGrid
                sx={{ height: 'auto', minHeight: 400, width: 'auto', fontFamily: 'Poppins', fontSize: '12px', color: '#272d3d', boxShadow: 0, border: 0 }}
                rowCount={customersState?.total}
                pagination
                loading={customersState?.isLoading}
                page={customersState?.page - 1}
                pageSizeOptions={[1, 10, 20, 50, 100]}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: customersState?.pageSize,
                      page: customersState?.page - 1,
                    },
                  },
                }}
                pageSize={customersState?.pageSize}
                onPaginationModelChange={(data) => {
                  const { pageSize, page } = data;
                  setCustomersState((old) => ({ ...old, page: page + 1, pageSize: pageSize }));
                }}
                paginationMode="server"
                columns={columns}
                rows={customersState?.data}
                getRowId={(row) => row._id}
                slots={{
                  toolbar: CustomToolbar,
                }}
              />
            </Grid>
          </TabPanel>
          <TabPanel value="ReturningCustomers" sx={{ ml: { xs: 0, sm: '-30px' }, px: { xs: 0, sm: 3 } }}>
            <Grid item>
              <DataGrid
                sx={{ height: 'auto', width: 'auto', fontFamily: 'Poppins', fontSize: '12px', color: '#272d3d', boxShadow: 0, border: 0, minHeight: 400 }}
                rowCount={customersState?.total}
                pagination
                loading={customersState?.isLoading}
                page={customersState?.page - 1}
                pageSizeOptions={[1, 10, 20, 50, 100]}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: customersState?.pageSize,
                      page: customersState?.page - 1,
                    },
                  },
                }}
                pageSize={customersState?.pageSize}
                onPaginationModelChange={(data) => {
                  const { pageSize, page } = data;
                  setCustomersState((old) => ({ ...old, page: page + 1, pageSize: pageSize }));
                }}
                paginationMode="server"
                columns={returningColumns}
                rows={customersState?.data}
                getRowId={(row) => row._id}
                slots={{
                  toolbar: CustomToolbar,
                }}
              />
            </Grid>
          </TabPanel>
          <TabPanel value="SalesByPaymentMode" sx={{ ml: { xs: 0, sm: '-30px' }, px: { xs: 0, sm: 3 } }}>
            <Grid item>
              <CustomTable columns={salesPerChannel} data={salesChannels} />

            </Grid>
          </TabPanel>
          <TabPanel value="MonthlySales" sx={{ ml: { xs: 0, sm: '-30px' }, px: { xs: 0, sm: 3 } }}>
            <Grid item>
              <CustomTable columns={monthlySalesColumns} data={salesData} />
            </Grid>
          </TabPanel>
          <TabPanel value="SalesByProducts" sx={{ ml: { xs: 0, sm: '-30px' }, px: { xs: 0, sm: 3 } }}>
            <Grid item>
              <DataGrid
                sx={{ height: 'auto', width: 'auto', fontFamily: 'Poppins', fontSize: '12px', color: '#272d3d', boxShadow: 0, border: 0, minHeight: 400 }}
                rowCount={salesPerProductState?.total}
                pagination
                loading={salesPerProductState.isLoading}
                page={salesPerProductState.page - 1}
                pageSizeOptions={[1, 10, 20, 50, 100]}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: salesPerProductState.pageSize,
                      page: salesPerProductState.page - 1,
                    },
                  },
                }}
                pageSize={salesPerProductState.pageSize}
                onPaginationModelChange={(data) => {
                  const { pageSize, page } = data;
                  setSalesPerProductState((old) => ({ ...old, page: page + 1, pageSize: pageSize }));
                }}
                paginationMode="server"
                columns={salesPerProductColumns}
                rows={salesPerProductState?.data}
                getRowId={(row) => row._id}
                slots={{
                  toolbar: CustomToolbar,
                }}
              />
            </Grid>
          </TabPanel>
          <TabPanel value="Transactions" sx={{ ml: { xs: 0, sm: '-30px' }, px: { xs: 0, sm: 3 } }}>
            <Grid item>
              <DataGrid
                sx={{ height: 'auto', minHeight: 400, width: 'auto', fontFamily: 'Poppins', fontSize: '12px', color: '#272d3d', boxShadow: 0, border: 0 }}
                rowCount={transactionsState?.total || 0}
                pagination
                loading={transactionsState.isLoading}
                page={transactionsState.page - 1}
                pageSizeOptions={[1, 10, 20, 50, 100]}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: transactionsState.pageSize,
                      page: transactionsState.page - 1,
                    },
                  },
                }}
                pageSize={transactionsState.pageSize}
                onPaginationModelChange={(data) => {
                  const { pageSize, page } = data;
                  setTransactionsState((old) => ({ ...old, page: page + 1, pageSize: pageSize }));
                }}
                paginationMode="server"
                columns={transactionsColumns}
                rows={transactionsState?.data || []}
                getRowId={(row) => row._id}
                slots={{
                  toolbar: CustomToolbar,
                }}
              />

            </Grid>
          </TabPanel>
        </TabContext>
      </Box>
    </Box>
  )
}
export default Reports;